import { render, staticRenderFns } from "./pages-sync.vue?vue&type=template&id=bdd43902"
import script from "./pages-sync.vue?vue&type=script&lang=js"
export * from "./pages-sync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports